/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AnsoegningKvittering } from '../models/ansoegning-kvittering';
@Injectable({
  providedIn: 'root',
})
class AnsoegningService extends __BaseService {
static readonly getKvitteringLinkPath = '/ansoegning/{ansoegningId}/kvitteringlink';
static readonly getKvitteringPath = '/ansoegning/{ansoegningId}/kvittering';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param ansoegningId undefined
   * @return Success
   */
  private getKvitteringLinkResponse(ansoegningId: string): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ansoegning/${encodeURIComponent(String(ansoegningId))}/kvitteringlink`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }

  /**
   * @param ansoegningId undefined
   * @return Success
   */
  getKvitteringLink(ansoegningId: string): __Observable<string> {
    return this.getKvitteringLinkResponse(ansoegningId).pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * @param ansoegningId undefined
   * @return Success
   */
  private getKvitteringResponse(ansoegningId: string): __Observable<__StrictHttpResponse<AnsoegningKvittering>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/ansoegning/${encodeURIComponent(String(ansoegningId))}/kvittering`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AnsoegningKvittering>;
      })
    );
  }

  /**
   * @param ansoegningId undefined
   * @return Success
   */
  getKvittering(ansoegningId: string): __Observable<AnsoegningKvittering> {
    return this.getKvitteringResponse(ansoegningId).pipe(
      __map(_r => _r.body as AnsoegningKvittering)
    );
  }
}

module AnsoegningService {
}

export { AnsoegningService }
